/**
 * Check if the game has ended
 * @param standing - The current standing of the game [left_side, right_side]
 * @returns 0 if left side won, 1 if right side won, -1 if no one won yet
 */
export function checkGameWinCondition(standing: number[]) {
    const leftSide = standing[0];
    const rightSide = standing[1];
    if ((leftSide >= 21 && leftSide - rightSide >= 2) || leftSide == 30) {
        return 0;
    }
    if ((rightSide >= 21 && rightSide - leftSide >= 2) || rightSide == 30) {
        return 1;
    }
    return -1;
}

export function checkMatchWinCondition(games: { homePoints: number; guestPoints: number }[]) {
    let homeWins = 0;
    let guestWins = 0;
    for (const game of games) {
        const winner = checkGameWinCondition([game.homePoints, game.guestPoints]);
        if (winner === 0) {
            homeWins += 1;
        } else if (winner === 1) {
            guestWins += 1;
        }
    }
    return {winner: check_match_win_condition([homeWins, guestWins]), standing: [homeWins, guestWins]};
}

/**
 * Check if the match has ended
 * @param standing - The current standing of the match [home_wins, guest_wins]
 * @returns 0 if home won, 1 if guest won, -1 if no team won yet
 */
export function check_match_win_condition(standing: number[]) {
    if (standing[0] === 2) {
        return 0;
    }
    if (standing[1] === 2) {
        return 1;
    }
    return -1;
}